/** Common ISO codes for the currency datalist; users can still type any code */
export const GAME_PROVIDER_CURRENCY_OPTIONS = [
  'USD',
  'EUR',
  'GBP',
  'VND',
  'THB',
  'JPY',
  'CNY',
  'KRW',
  'MYR',
  'SGD',
  'PHP',
  'IDR',
  'AUD',
  'CAD',
  'HKD',
  'TWD',
  'INR',
  'BRL',
  'MXN',
  'NZD',
  'CHF',
  'AED',
  'SAR',
] as const;

export const GAME_PROVIDER_CURRENCY_DATALIST_ID = 'game-provider-currency-datalist';

export const gameProviderNativeSelectClass =
  'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50';

export const gameProviderTextareaClass =
  'min-h-[5rem] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-y';
